import { createHelp, updateHelp, deleteHelp, helpsStart, fetchHelps, helpsError } from '@redux/reducers/helpReducer';
import { Help } from '@components/types/help/types';
import { AppThunk } from '@redux/stores/store';
import api from '@api/index';
import { AxiosResponse } from 'axios';

export interface ICreateHelpAction {
  type: typeof createHelp;
  payload: Partial<Help>;
}

export interface IUpdateHelpAction {
  type: typeof updateHelp;
  payload: Help;
}

export interface IDeleteHelpAction {
  type: typeof deleteHelp;
  payload: { _id: string };
}
export interface IFetchHelpsAction {
  type: typeof fetchHelps;
  payload: Help[];
}

export interface IHelpsStartAction {
  type: typeof helpsStart;
}


export interface IHelpsErrorAction {
  type: typeof helpsError;
  payload: string;
}

export type THelpeActionTypes =
  | ICreateHelpAction
  | IUpdateHelpAction
  | IDeleteHelpAction
  | IFetchHelpsAction
  | IHelpsStartAction
  | IHelpsErrorAction;

export function createHelpAction(help: Partial<Help>): AppThunk {
  return async dispatch => {
    try {
      dispatch(helpsStart());
      const response = await api.post('/help', { ...help });
      dispatch(createHelp(response.data));
    } catch (error) {
      dispatch(helpsError(error));
    }
  }
}

export function updateHelpAction(help: Help): AppThunk {
  return async dispatch => {
    try {
      dispatch(helpsStart());
      const { _id } = help;
      const response = await api.patch(`/help/update/${_id}`, help);
      dispatch(updateHelp(response.data));
    } catch (error) {
      dispatch(helpsError(error));
    }
  }
}

export function deleteHelpAction(_id: string): AppThunk {
  return async dispatch => {
    try {
      dispatch(helpsStart());
      await api.delete(`/help/${_id}`);
      dispatch(deleteHelp({_id}));
    } catch (error) {
      dispatch(helpsError(error));
    }
  }
}


export const fetchHelpAction = (_id: string): AppThunk => async dispatch => {
  try {
    dispatch(helpsStart());
    const response: AxiosResponse<Help> = await api.get(`/help/${_id}`);
    dispatch(fetchHelps([response.data]));
  } catch (error) {
    dispatch(helpsError(error));
  }
};

export const fetchHelpsAction = (): AppThunk => async dispatch => {
  try {
    dispatch(helpsStart());
    const response: AxiosResponse<Help[]> = await api.get(`/help`);
    dispatch(fetchHelps(response.data));
  } catch (error) {
    dispatch(helpsError(error));
  }
};
